import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PurchaseColumns } from "./columns";
import { selectPrefix, selectWidth } from "../utility/Redux/profile";
import {
  ModifyButton,
  PrintButton,
  SaveButton,
  UndoButton,
} from "../utility/component/buttons";
import axios from "axios"
import moment from "moment";
import GeniustextInput from "../utility/component/mastertext";
import EditableDataGrid from "../utility/component/datagrid/editableDatagrid";
import {
  setAlertWithTitle,
  setIssueStockItem,
  setSpinnerLoading,
  setnumericKeyboardStatus,
  setnumericKeyboardType,
} from "../utility/Redux/modal";
import uniqeId from "uniqid";
import ModNumericKeyboard from "../utility/component/modalNumeric";
import CustomHeader from "./printReportHeader";
import { PrintColumns } from "./printColumns";
import Footer from "./printReportFooter";
import { toProperCase } from "../utility/component/format";
import { ItemMasterHelp } from "../help";
import TextBoxMui from "../utility/component/textBoxMui";
import FirstIcodeItem from "./icodeEnterValue";
import { IsEnterPressed } from "../utility/functions/common";
import {
  FormatNumber2,
  IscontainsAlphabetic,
} from "../utility/functions/formatNumber";
import { selectToken } from "../utility/Redux/security";
import BarcodeScanner from "../utility/component/barcodeScanner";
import IsCameraAvailval from "../utility/functions/isCameraAvailvl";
import { getItemByAlios, getItemByCode } from "../utility/constant";
import { enterRowWithItemDetails } from "./fun";
import GeniusTableForReports from "../utility/component/datagrid/printReportWithFooter";
import { CallAPIPromise, apiClient } from "../billing/common";

const PURCHASE_SCAN_ENDPOINT = "/api/purchaseOpenAi/purchase-details";
const PURCHASE_SCAN_HISTORY_LIMIT = 30;

const emptyText = (value) =>
  value === null || value === undefined || value === "" ? "-" : value;

const normalizeValue = (value) =>
  (value || "")
    .toString()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

const uniqueByKey = (list, key) => {
  const found = new Set();
  return list.filter((item) => {
    const value = item?.[key];
    if (!value || found.has(value)) {
      return false;
    }
    found.add(value);
    return true;
  });
};

const scoreTextMatch = (source, target, points) => {
  const cleanSource = normalizeValue(source);
  const cleanTarget = normalizeValue(target);

  if (!cleanSource || !cleanTarget) {
    return 0;
  }

  if (cleanSource === cleanTarget) {
    return points;
  }

  if (cleanSource.includes(cleanTarget) || cleanTarget.includes(cleanSource)) {
    return Math.round(points * 0.75);
  }

  return 0;
};

const Datagrid = ({
  savePurchaseBill,
  setItemMasterStatus,
  setBarCodeListStatus,
  setIsClearData,
  setBarCodeList,
  delayedFunction,
  setPartyDetails,
  partyDetails,
  rows,
  setRows,
  alertTwoButtonModal,
  totalSum,
  vatTotal,
  cessTotal,
  cgstTotal,
  sgstTotal,
  igstTotal,
  disqTotal,
  qntyTotal,
  surchargeTotal,
  tcsTotal,
  roundOff,
  grandTotal,
  clearState,
  setAccountMasterHelpStatus,
  muiTextBox,
  currentINVNO,
  inputRef,
  frieghtRef,
  setAlertTwoButtonModal,
}) => {
  const width = useSelector(selectWidth);
  const columns = PurchaseColumns(width);
  const [lastPrice, setLastPrice] = useState("");
  const printColumns = PrintColumns(width);
  const [searchText, setSearchText] = useState("");
  const [itemMasterHelpStatus, setItemMasterHelpStatus] = useState(false);
  const [scannerItem, setScannerItem] = useState("");
  const prefix = useSelector(selectPrefix);
  const token = useSelector(selectToken);
  const [rowId, setRowId] = useState("");
  const dispatch = useDispatch();
  const [isDeviceHaveCamera, setIsDeviceHaveCamera] = useState(false);
  const [scannerStatus, setScannerStatus] = useState(false);
  const [file, setFile] = useState("");
  const [pdfModalStatus, setPdfmodalStatus] = useState(false);
  const [purchasePdfDetails, setPurchasePdfDetails] = useState(null);
  const [resolvedPurchasePdfDetails, setResolvedPurchasePdfDetails] =
    useState(null);
  const [scanFileName, setScanFileName] = useState("");
  const [scanHistoryStatus, setScanHistoryStatus] = useState(false);
  const [scannedPurchaseHistory, setScannedPurchaseHistory] = useState([]);
  const keyDown = (e, currentFieldName, id) => {
    const value = e.target.value;

    if (currentFieldName === "ICODE" && e.code === "F4") {
      if (partyDetails.NAME) {
        setRowId(id);
        setItemMasterHelpStatus(true);
      } else {
        setAlertTwoButtonModal({
          ...alertTwoButtonModal,
          status: true,
          title: "Alert",
          msg: "Please Select party First.",
          button1: "ok",

          button1Click: () => {
            setAlertTwoButtonModal({
              ...alertTwoButtonModal,
              status: false,
            });
            setAccountMasterHelpStatus(true);
          },
        });
      }
    } else {
      if (
        (currentFieldName === "ICODE" &&
          e.code === "Enter" &&
          value !== "" &&
          value !== "0") ||
        (e.code === "NumpadEnter" &&
          value !== "" &&
          value !== "0" &&
          currentFieldName === "ICODE")
      ) {
        if (partyDetails.NAME) {
          if (!isNaN(value)) {
            const v = value.toString().replace(" ", "");
            if (v) {
              const isFilled = rows.find((r) => r.id === id);
              if (!isFilled?.ITEMNAME) {
                if (
                  !rows.find((o) => {
                    if (o.ITEMNAME) {
                      if (Number(o.ICODE) === Number(value) && o.id !== id) {
                        return o; // Return the object if condition matches
                      }
                      if (
                        o?.ALIAS_CODE?.toString() === value.toString() &&
                        o.id !== id
                      ) {
                        return o; // Return the object if condition matches
                      }
                    }
                    return false;
                  })
                ) {
                  if (
                    e.code === "Enter" ||
                    e.code === "NumpadEnter" ||
                    e.code === "ArrowRight"
                  ) {
                    const currentFieldIndex = columns.findIndex(
                      (column) => column.field === currentFieldName
                    );
                    const nextEditableField = columns.find(
                      (column, index) =>
                        index > currentFieldIndex && column.editable
                    );
                    if (nextEditableField) {
                      const nearestInput = document.getElementById(
                        id + "-" + nextEditableField.field
                      );
                      setTimeout(() => {
                        if (nearestInput) {
                          nearestInput.focus();
                          nearestInput.select();
                        }
                      }, 2000);
                    }
                  }
                  getItemByCode(prefix, value, token, dispatch, true).then(
                    (codeItem) => {
                      if (!codeItem[0]) {
                        getItemByAlios(
                          prefix,
                          value,
                          token,
                          dispatch,
                          true
                        ).then((aliosItem) => {
                          enterRowWithItemDetails(
                            aliosItem,
                            rows,
                            id,
                            prefix,
                            partyDetails,
                            token,
                            dispatch,
                            setLastPrice,
                            setRows,
                            value,
                            setAlertTwoButtonModal,
                            setItemMasterStatus
                          );
                        });
                      } else {
                        enterRowWithItemDetails(
                          codeItem,
                          rows,
                          id,
                          prefix,
                          partyDetails,
                          token,
                          dispatch,
                          setLastPrice,
                          setRows,
                          value,
                          setAlertTwoButtonModal,
                          setItemMasterStatus
                        );
                      }
                    }
                  );
                } else {
                  setAlertTwoButtonModal((o) => {
                    return {
                      ...o,
                      status: true,
                      title: "Alert",
                      msg: "Item already exist",
                      button1: "ok",
                      button1Click: () => {
                        setAlertTwoButtonModal((o) => {
                          return {
                            ...o,
                            status: false,
                          };
                        });
                      },
                    };
                  });
                }
              } else {
                const currentFieldIndex = columns.findIndex(
                  (column) => column.field === currentFieldName
                );
                const nextEditableField = columns.find(
                  (column, index) =>
                    index > currentFieldIndex && column.editable
                );
                if (nextEditableField) {
                  const nearestInput = document.getElementById(
                    id + "-" + nextEditableField.field
                  );
                  if (nearestInput) {
                    nearestInput.focus();
                    nearestInput.select();
                  }
                }
              }
            } else {
              dispatch(
                setAlertWithTitle({
                  title: "Alert",
                  msg: "Please enter Icode to continue",
                })
              );
            }
          } else {
            setRows((r) =>
              r.map((o) => {
                if (o.id === id) {
                  return {
                    ...o,
                    ICODE: "",
                  };
                } else {
                  return o;
                }
              })
            );
            setSearchText(value);
            setRowId(id);
            setItemMasterHelpStatus(true);
          }
        } else {
          setAlertTwoButtonModal({
            ...alertTwoButtonModal,
            status: true,
            title: "Alert",
            msg: "Please Select party First.",
            button1: "ok",

            button1Click: () => {
              setAlertTwoButtonModal({
                ...alertTwoButtonModal,
                status: false,
              });
              setAccountMasterHelpStatus(true);
            },
          });
        }
      } else {
        if (currentFieldName === "ICODE") {
          setAlertTwoButtonModal({
            ...alertTwoButtonModal,
            status: true,
            title: "Alert",
            msg: "Please Enter Item Code First.",
            button1: "ok",

            button1Click: () => {
              setAlertTwoButtonModal({
                ...alertTwoButtonModal,
                status: false,
              });
            },
          });
        } else {
          if (
            e.code === "Enter" ||
            e.code === "NumpadEnter" ||
            e.code === "ArrowRight"
          ) {
            const currentFieldIndex = columns.findIndex(
              (column) => column.field === currentFieldName
            );
            const nextEditableField = columns.find(
              (column, index) => index > currentFieldIndex && column.editable
            );
            if (nextEditableField) {
              const nearestInput = document.getElementById(
                id + "-" + nextEditableField.field
              );
              if (nearestInput) {
                nearestInput.focus();
                nearestInput.select();
              }
            }
          }
        }
      }
    }
  };

  const nextRow = (index) => {
    delayedFunction(rows[index].id);
  };
  const deletRow = (id) => {
    setRows((o) => {
      const list = o.filter((r) => r.id !== id);
      if (list.find((o) => o.ITEMNAME === "")) {
        return list;
      } else {
        return [
          ...list,
          {
            id: uniqeId(),
            INVNO: "",
            DATE: moment().format("YYYY-MM-DD"),
            PUR_BILL_NO: "",
            PUR_BILL_DATE: moment().format("YYYY-MM-DD"),
            PUR_BILL_AMOUNT: "0",
            ENT_TIME: moment().format("YYYY-MM-DD"),
            BILL_MODE: rows[0].BILL_MODE,
            BILL_TYPE: rows[0].BILL_TYPE,
            ACCOUNT_NO: "",
            NAME: "",
            ADDRESS: "",
            MOBILE: "",
            TAX_NUMBER: "",
            ICODE: "",
            ITEMNAME: "",
            PACKING: "",
            UNIT: "",
            SECTION_NAME: "",
            SUB_SEC_NAME: "",
            BRAND_NAME: "",
            PUR_PRICE: "0",
            MRP_RATE: "0",
            SALE_PRICE: "0",
            QNTY: "0",
            AMOUNT: "0",
            DISQ_RT: "0",
            DISQ_AMT: "0",
            TAX1_RATE: "0",
            TAX1_AMT: "0",
            TAX2_RATE: "0",
            TAX2_AMT: "0",
            TAX3_RATE: "0",
            TAX3_AMT: "0.00",
            NET_AMT: "0.00",
            BASIC_RATE: "0.00",
            BASIC_AMT: "0.00",
            TOTAL: "0",
            FREIGHT: "0.00",
            REMARKS: "",
            ROUND_OFF: "0",
            GTOTAL: "0",
            HSN_CODE: "",
            GR_NO: "0",
            PO_NO: "0",
            INCL_EXCL: "Excluded",
            CESS_RATE: "0",
            CESS_AMOUNT: "0",
            TCS_RATE: "0",
            TCS_AMOUNT: "0",
            ADDITIONAL_CESS: "0",
            VAT_AMOUNT: "0",
            SURCHARGE_RATE: "0",
            SURCHARGE_AMT: "0.00",
            VAT_RATE: "0",
            SCHEME_RATE: "0",
            SCHEME_AMOUNT: "0.00",
            TOTAL_SCHEME_AMOUNT: "0.00",
            ADD_CHARGES: "0.00",
            LESS_CHARGES: "0.00",
            INCL_TAX: "No",
            DEP_NAME: "",
            PURCHASE_PIC: "",
            EXP_DATE: "",
            BATCH: "",
            MARK_RATE: 0,
            FREE_QNTY: 0,
          },
        ];
      }
    });
  };

  const CellEdit = ({ id, field, value }) => {
    if (field === "ICODE") {
      const isSameIdExist = rows.filter((row) => row.id === id);
      if (isSameIdExist[0]) {
        setRows((old) =>
          old.map((item) => {
            if (item.id === id && !item.ITEMNAME) {
              return {
                ...item,
                ICODE: value,
                INVNO: "",
                DATE: moment().format("YYYY-MM-DD"),
                PUR_BILL_NO: "",
                PUR_BILL_DATE: moment().format("YYYY-MM-DD"),
                PUR_BILL_AMOUNT: "0",
                ENT_TIME: moment().format("YYYY-MM-DD"),

                ACCOUNT_NO: "",
                NAME: "",
                ADDRESS: "",
                MOBILE: "",
                TAX_NUMBER: "",
                ITEMNAME: "",
                PACKING: "",
                UNIT: "",
                SECTION_NAME: "",
                SUB_SEC_NAME: "",
                BRAND_NAME: "",
                PUR_PRICE: "0",
                MRP_RATE: "0",
                SALE_PRICE: "0",
                QNTY: "0",
                AMOUNT: "0",
                DISQ_RT: "0",
                DISQ_AMT: "0",
                TAX1_RATE: "0",
                TAX1_AMT: "0",
                TAX2_RATE: "0",
                TAX2_AMT: "0",
                TAX3_RATE: "0",
                TAX3_AMT: "0.00",
                NET_AMT: "0.00",
                BASIC_RATE: "0.00",
                BASIC_AMT: "0.00",
                TOTAL: "0",
                FREIGHT: "0.00",
                REMARKS: "",
                ROUND_OFF: "0",
                GTOTAL: "0",
                HSN_CODE: "",
                GR_NO: "0",
                PO_NO: "0",
                INCL_EXCL: "Excluded",
                CESS_RATE: "0",
                CESS_AMOUNT: "0",
                TCS_RATE: "0",
                TCS_AMOUNT: "0",
                ADDITIONAL_CESS: "0",
                VAT_AMOUNT: "0",
                SURCHARGE_RATE: "0",
                SURCHARGE_AMT: "0.00",
                VAT_RATE: "0",
                SCHEME_RATE: "0",
                SCHEME_AMOUNT: "0.00",
                TOTAL_SCHEME_AMOUNT: "0.00",
                ADD_CHARGES: "0.00",
                LESS_CHARGES: "0.00",
                INCL_TAX: "No",
                DEP_NAME: "",
                PURCHASE_PIC: "",
                EXP_DATE: "",
                BATCH: "",
              };
            } else {
              return item;
            }
          })
        );
      } else {
        setRows((old) => {
          return [
            ...old,
            {
              ...old[0],
              ICODE: value,
              INVNO: "",
              DATE: moment().format("YYYY-MM-DD"),
              PUR_BILL_NO: "",
              PUR_BILL_DATE: moment().format("YYYY-MM-DD"),
              PUR_BILL_AMOUNT: "0",
              ENT_TIME: moment().format("YYYY-MM-DD"),
              ACCOUNT_NO: "",
              NAME: "",
              ADDRESS: "",
              MOBILE: "",
              TAX_NUMBER: "",
              ITEMNAME: "",
              PACKING: "",
              UNIT: "",
              SECTION_NAME: "",
              SUB_SEC_NAME: "",
              BRAND_NAME: "",
              PUR_PRICE: "0",
              MRP_RATE: "0",
              SALE_PRICE: "0",
              QNTY: "0",
              AMOUNT: "0",
              DISQ_RT: "0",
              DISQ_AMT: "0",
              TAX1_RATE: "0",
              TAX1_AMT: "0",
              TAX2_RATE: "0",
              TAX2_AMT: "0",
              TAX3_RATE: "0",
              TAX3_AMT: "0.00",
              NET_AMT: "0.00",
              BASIC_RATE: "0.00",
              BASIC_AMT: "0.00",
              TOTAL: "0",
              FREIGHT: "0.00",
              REMARKS: "",
              ROUND_OFF: "0",
              GTOTAL: "0",
              HSN_CODE: "",
              GR_NO: "0",
              PO_NO: "0",
              INCL_EXCL: "Excluded",
              CESS_RATE: "0",
              CESS_AMOUNT: "0",
              TCS_RATE: "0",
              TCS_AMOUNT: "0",
              ADDITIONAL_CESS: "0",
              VAT_AMOUNT: "0",
              SURCHARGE_RATE: "0",
              SURCHARGE_AMT: "0.00",
              VAT_RATE: "0",
              SCHEME_RATE: "0",
              SCHEME_AMOUNT: "0.00",
              TOTAL_SCHEME_AMOUNT: "0.00",
              ADD_CHARGES: "0.00",
              LESS_CHARGES: "0.00",
              INCL_TAX: "No",
              DEP_NAME: "",
              PURCHASE_PIC: "",
              EXP_DATE: "",
              BATCH: "",
            },
          ];
        });
      }
    }

    if (
      field === "QNTY" ||
      field === "PUR_PRICE" ||
      field === "DISQ_RT" ||
      field === "DISQ_AMT" ||
      // field === "VAT_AMOUNTT" ||
      field === "VAT_RATE" ||
      field === "CESS_RATE" ||
      field === "SURCHARGE_AMT" ||
      field === "SURCHARGE_RATE" ||
      field === "BATCH" ||
      field === "EXP_DATE" ||
      field === "FREE_QNTY" ||
      field === "TAX1_RATE" ||
      field === "TAX2_RATE" ||
      field === "TAX3_RATE"
    ) {
      if (
        !isNaN(value) ||
        field === "EXP_DATE" ||
        field === "BATCH" ||
        (value.includes("-") &&
          !value.includes("--") &&
          field === "QNTY" &&
          !IscontainsAlphabetic(value))
      ) {
        const updatedRows = rows.map((row) => {
          if (row.id === id) {
            const qnty =
              field === "QNTY"
                ? value.includes("-")
                  ? -value.replace("-", "")
                  : value
                : row.QNTY;

            const pur_price =
              field === "PUR_PRICE" ? Number(value) : row.PUR_PRICE;
            const diq_rate =
              field === "DISQ_RT"
                ? value
                  ? parseFloat(value)
                  : "0"
                : field === "DISQ_AMT"
                ? (
                    (parseFloat(value) /
                      (parseFloat(qnty) * parseFloat(pur_price))) *
                    100
                  ).toFixed(2)
                : row.DISQ_RT;
            const diq_amt =
              field === "DISQ_AMT"
                ? Number(value)
                : field === "DISQ_RT"
                ? (parseFloat(qnty) *
                    parseFloat(pur_price) *
                    parseFloat(value)) /
                  100
                : row.DISQ_AMT;
            const tax1_rate =
              field === "TAX1_RATE" ? Number(value) : row.TAX1_RATE;
            const tax2_rate =
              field === "TAX2_RATE" ? Number(value) : row.TAX2_RATE;
            const tax3_rate =
              field === "TAX3_RATE" ? Number(value) : row.TAX3_RATE;
            const vat_rate =
              field === "VAT_RATE"
                ? parseFloat(value)
                : field === "VAT_AMOUNT"
                ? (parseFloat(value) / 100) * parseFloat(pur_price)
                : row.VAT_RATE;
            const tcs_rate = 0;
            const css_rate =
              field === "CESS_RATE" ? Number(value) : row.CESS_RATE;
            const surcharge_rate =
              field === "SURCHARGE_RATE"
                ? value
                : field === "SURCHARGE_AMT"
                ? (parseFloat(value) / 100) * parseFloat(pur_price)
                : row.SURCHARGE_RATE;

            const EXP_DATE = field === "EXP_DATE" ? value : row.EXP_DATE;

            if (diq_amt > pur_price * qnty && !qnty.toString().includes("-")) {
              dispatch(
                setAlertWithTitle({
                  title: "Alert",
                  msg: "Dicount amount can not be more than Purchase Price.",
                })
              );

              return row;
            }
            const item = rows.filter((i) => i.id === id);
            const batch = field === "BATCH" ? value : item[0].BATCH;
            if (field === "EXP_DATE") {
              return {
                ...row,
                EXP_DATE: EXP_DATE,
              };
            }

            if (field === "BATCH") {
              return {
                ...row,
                BATCH: batch,
              };
            }

            if (field === "FREE_QNTY") {
              return {
                ...row,
                FREE_QNTY: value,
              };
            }
            const i = FirstIcodeItem(
              id,
              qnty,
              pur_price,
              diq_rate,
              diq_amt,
              tax1_rate,
              tax2_rate,
              tax3_rate,
              vat_rate,
              tcs_rate,
              surcharge_rate,

              partyDetails,
              item[0],
              EXP_DATE,
              value,
              css_rate
            );
            return i;
            // getItemByCode(prefix,row.ICODE,token,dispatch).then(item =>{

            // })
          }
          return row;
        });

        setRows(updatedRows);
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Please Enter Number Value",
          })
        );
      }
    }
  };
  useEffect(() => {
    IsCameraAvailval()
      .then(() => {
        setIsDeviceHaveCamera(true);
      })
      .catch(() => {
        setIsDeviceHaveCamera(false);
      });
  }, []);
  const windowWidth = useSelector(selectWidth);
  const footerGrid =
    "mt-3 grid grid-cols-[150px,150px] d:grid-cols-[120px,120px,120px] 2xl:grid-cols-[120px,120px,120px,120px] gap-3 ";
  const footerGrid2 = "mt-3 grid ll:grid-cols-2 grid-cols-1 gap-3";
  const footerGrid3 = "mt-3 grid grid-cols-1 gap-3";
  const handleButtonClick = () => {
    document.getElementById("fileInput").click();
  };

  const scanHistoryKey = `purchase_pdf_scan_history_${prefix || "default"}`;

  const loadScannedPurchaseHistory = () => {
    try {
      const history = JSON.parse(localStorage.getItem(scanHistoryKey) || "[]");
      setScannedPurchaseHistory(Array.isArray(history) ? history : []);
    } catch {
      setScannedPurchaseHistory([]);
    }
  };

  const saveScannedPurchaseHistory = (scannedDetails, resolvedDetails, fileName) => {
    const entry = {
      id: uniqeId(),
      scannedAt: new Date().toISOString(),
      fileName,
      documentNumber: scannedDetails?.documentNumber || "",
      issueDate: scannedDetails?.issueDate || "",
      sellerName: scannedDetails?.partyDetails?.seller?.name || "",
      grandTotal: scannedDetails?.totals?.grandTotal || "",
      data: scannedDetails,
      resolved: resolvedDetails,
    };

    const nextHistory = [entry, ...scannedPurchaseHistory].slice(
      0,
      PURCHASE_SCAN_HISTORY_LIMIT
    );
    setScannedPurchaseHistory(nextHistory);
    localStorage.setItem(scanHistoryKey, JSON.stringify(nextHistory));
  };

  const openScannedHistoryEntry = (entry) => {
    setPurchasePdfDetails(entry.data);
    setResolvedPurchasePdfDetails(entry.resolved || null);
    setScanFileName(entry.fileName || "Scanned purchase PDF");
    setScanHistoryStatus(false);
    setPdfmodalStatus(true);
  };

  useEffect(() => {
    loadScannedPurchaseHistory();
  }, [scanHistoryKey]);

  const handlePdfScan = async (selectedFile) => {
    if (!selectedFile) {
      return;
    }

    if (selectedFile.type !== "application/pdf") {
      dispatch(
        setAlertWithTitle({
          title: "Alert",
          msg: "Please select a PDF file.",
        })
      );
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    setFile(selectedFile);
    setScanFileName(selectedFile.name);
    setPurchasePdfDetails(null);
    setResolvedPurchasePdfDetails(null);
    dispatch(setSpinnerLoading("Scanning purchase PDF"));

    try {
      apiClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      const res = await apiClient.post(PURCHASE_SCAN_ENDPOINT, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data?.success) {
        const scannedDetails = res.data.data;
        const resolvedDetails = await resolveScannedPurchase(scannedDetails);
        setPurchasePdfDetails(scannedDetails);
        setResolvedPurchasePdfDetails(resolvedDetails);
        saveScannedPurchaseHistory(
          scannedDetails,
          resolvedDetails,
          selectedFile.name
        );
        setPdfmodalStatus(true);
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: res.data?.error || "Unable to scan purchase PDF.",
          })
        );
      }
    } catch (error) {
      dispatch(
        setAlertWithTitle({
          title: "Alert",
          msg:
            error.response?.data?.error ||
            error.response?.data?.message ||
            "Failed to scan purchase PDF.",
        })
      );
    } finally {
      dispatch(setSpinnerLoading(false));
    }
  };

  const listAccountsForScan = async (seller) => {
    const searches = [];
    const phone = seller?.phone?.replace(/\D/g, "");
    const name = seller?.name || "";

    if (phone) {
      searches.push({ mobile: phone, name: "" });
    }
    if (name) {
      searches.push({ mobile: "", name });
    }

    if (!searches.length) {
      return [];
    }

    const responses = await Promise.all(
      searches.map((search) =>
        CallAPIPromise(
          "/api/accountMaster/listAccountMaster",
          {
            table_prefix: prefix,
            SECTION_NAME: "",
            mobile: search.mobile,
            name: search.name,
            page: 1,
            limit: 100,
          },
          token,
          true
        ).catch(() => null)
      )
    );

    return uniqueByKey(
      responses.flatMap((response) => response?.data?.response?.data || []),
      "ACCOUNT_NO"
    );
  };

  const scoreParty = (seller, party) => {
    let score = 0;
    const reasons = [];

    if (
      normalizeValue(seller?.taxId) &&
      normalizeValue(seller?.taxId) === normalizeValue(party?.TAX_NUMBER)
    ) {
      score += 60;
      reasons.push("GST match");
    }

    if (
      seller?.phone &&
      seller.phone.replace(/\D/g, "") === (party?.MOBILE || "").replace(/\D/g, "")
    ) {
      score += 30;
      reasons.push("phone match");
    }

    const nameScore = scoreTextMatch(seller?.name, party?.NAME, 30);
    if (nameScore) {
      score += nameScore;
      reasons.push("name match");
    }

    const addressScore = scoreTextMatch(seller?.address, party?.ADDRESS, 10);
    if (addressScore) {
      score += addressScore;
      reasons.push("address match");
    }

    return {
      party,
      score: Math.min(score, 100),
      status: score >= 20 ? "matched" : score > 0 ? "review" : "unmatched",
      reasons,
    };
  };

  const listItemsForScan = async (pdfItem) => {
    const searches = [];
    const sku = pdfItem?.sku || "";
    const itemName = pdfItem?.itemName || pdfItem?.description || "";

    if (sku) {
      searches.push({ ICODE: sku, ITEMNAME: "" });
    }
    if (itemName) {
      searches.push({ ICODE: "", ITEMNAME: itemName });
    }

    if (!searches.length) {
      return [];
    }

    const responses = await Promise.all(
      searches.map((search) =>
        CallAPIPromise(
          "/api/itemMasterUtils/listItemMaster",
          {
            table_prefix: prefix,
            SECTION_NAME: "",
            ICODE: search.ICODE,
            ALIAS_CODE: "",
            ITEMNAME: search.ITEMNAME,
            page: 1,
            limit: 100,
            IS_MASTER: "No",
          },
          token,
          true
        ).catch(() => null)
      )
    );

    return uniqueByKey(
      responses.flatMap((response) => response?.data?.response?.data || []),
      "ICODE"
    );
  };

  const scoreItem = (pdfItem, dbItem) => {
    let score = 0;
    const reasons = [];

    if (
      normalizeValue(pdfItem?.sku) &&
      (normalizeValue(pdfItem?.sku) === normalizeValue(dbItem?.ICODE) ||
        normalizeValue(pdfItem?.sku) === normalizeValue(dbItem?.ALIAS_CODE))
    ) {
      score += 70;
      reasons.push("code match");
    }

    if (
      normalizeValue(pdfItem?.hsnSac) &&
      normalizeValue(pdfItem?.hsnSac) === normalizeValue(dbItem?.HSN_CODE)
    ) {
      score += 15;
      reasons.push("HSN match");
    }

    const nameScore = scoreTextMatch(
      pdfItem?.itemName || pdfItem?.description,
      dbItem?.ITEMNAME,
      35
    );
    if (nameScore) {
      score += nameScore;
      reasons.push("name match");
    }

    if (
      pdfItem?.rate &&
      dbItem?.PUR_PRICE &&
      Math.abs(Number(pdfItem.rate) - Number(dbItem.PUR_PRICE)) <= 1
    ) {
      score += 10;
      reasons.push("rate close");
    }

    return {
      item: dbItem,
      score: Math.min(score, 100),
      status: score >= 20 ? "matched" : score > 0 ? "review" : "unmatched",
      reasons,
    };
  };

  const resolveScannedPurchase = async (scannedDetails) => {
    dispatch(setSpinnerLoading("Matching PDF with masters"));

    const seller = scannedDetails?.partyDetails?.seller || {};
    const partyCandidates = await listAccountsForScan(seller);
    const partyMatches = partyCandidates
      .map((party) => scoreParty(seller, party))
      .sort((a, b) => b.score - a.score);

    const items = scannedDetails?.items || [];
    const resolvedItems = await Promise.all(
      items.map(async (pdfItem) => {
        const itemCandidates = await listItemsForScan(pdfItem);
        const matches = itemCandidates
          .map((dbItem) => scoreItem(pdfItem, dbItem))
          .sort((a, b) => b.score - a.score);

        return {
          pdfItem,
          bestMatch: matches[0] || null,
          matches,
        };
      })
    );

    return {
      party: {
        seller,
        bestMatch: partyMatches[0] || null,
        matches: partyMatches,
      },
      items: resolvedItems,
      readyToApply:
        partyMatches[0]?.status === "matched" ||
        resolvedItems.some((item) => item.bestMatch?.status === "matched"),
    };
  };

  const applyScannedPurchaseToBill = () => {
    if (!purchasePdfDetails || !resolvedPurchasePdfDetails) {
      return;
    }

    const matchedParty = resolvedPurchasePdfDetails.party.bestMatch;
    const matchedItems = resolvedPurchasePdfDetails.items.filter(
      (item) => item.bestMatch?.status === "matched"
    );

    if (!matchedParty && !matchedItems.length) {
      dispatch(
        setAlertWithTitle({
          title: "Alert",
          msg: "No party or item match found above 20% to apply.",
        })
      );
      return;
    }

    const party = matchedParty?.party || {};
    const nextPartyDetails = {
      ...partyDetails,
      NAME: party.NAME || partyDetails.NAME,
      ADDRESS: party.ADDRESS || partyDetails.ADDRESS,
      MOBILE: party.MOBILE || partyDetails.MOBILE,
      TAX_NUMBER: party.TAX_NUMBER || partyDetails.TAX_NUMBER,
      ACCOUNT_NO: party.ACCOUNT_NO || partyDetails.ACCOUNT_NO,
      PUR_BILL_NO: purchasePdfDetails.documentNumber || "",
      PUR_BILL_DATE: purchasePdfDetails.issueDate || partyDetails.PUR_BILL_DATE,
      PUR_BILL_AMOUNT:
        purchasePdfDetails.totals?.grandTotal ||
        purchasePdfDetails.totals?.balanceDue ||
        partyDetails.PUR_BILL_AMOUNT,
      REMARKS: purchasePdfDetails.notes || partyDetails.REMARKS,
    };

    const nextRows = matchedItems.map(({ pdfItem, bestMatch }) => {
      const dbItem = bestMatch.item;
      const id = uniqeId();
      return FirstIcodeItem(
        id,
        pdfItem.quantity || 0,
        pdfItem.rate || dbItem.PUR_PRICE || 0,
        0,
        pdfItem.discount || 0,
        dbItem.TAX1_RATE || 0,
        dbItem.TAX2_RATE || 0,
        dbItem.TAX3_RATE || 0,
        dbItem.VAT_RATE || 0,
        dbItem.TCS_RATE || 0,
        dbItem.SURCHARGE_RATE || 0,
        nextPartyDetails,
        dbItem,
        "",
        "",
        dbItem.CESS_RATE || 0
      );
    });

    setPartyDetails(nextPartyDetails);
    if (nextRows.length) {
      setRows([
        ...nextRows,
        {
          ...rows[0],
          id: uniqeId(),
          ICODE: "",
          ITEMNAME: "",
          QNTY: "0",
          PUR_PRICE: "0",
          AMOUNT: "0",
        },
      ]);
    }
    setPdfmodalStatus(false);
  };

  return (
    <div
      style={{
        height: `calc(100% - ${windowWidth > 1440 ? "141px" : "200px"})`,
      }}
      className="  w-auto "
    >
      <div className="flex text-red-500 pb-2">
        <div className="font-semibold mr-3">Last Purchase Price</div> :
        <div className="ml-3">{lastPrice && FormatNumber2(lastPrice)}</div>
        <input
          id="fileInput"
          type="file"
          accept="application/pdf"
          className="hidden"
          onChange={(event) => {
            const selectedFile = event.target.files?.[0];
            handlePdfScan(selectedFile);
            event.target.value = "";
          }}
        />
        <button
          type="button"
          onClick={handleButtonClick}
          className="ml-auto rounded-md border border-[#e94a05] bg-white px-3 py-1 text-[13px] font-semibold text-[#e94a05] shadow-sm hover:bg-[#fff7ed]"
        >
          Scan Your Purchase PDF
        </button>
        <button
          type="button"
          onClick={() => setScanHistoryStatus(true)}
          className="ml-2 rounded-md border border-gray-300 bg-white px-3 py-1 text-[13px] font-semibold text-gray-700 shadow-sm hover:bg-gray-50"
        >
          Scanned PDF History
        </button>
      </div>
      <div
        style={{
          height: `calc(100% - ${
            windowWidth < 1280
              ? "380px"
              : windowWidth < 1536
              ? "260px"
              : windowWidth < 1800
              ? "280px"
              : "240px"
          })`,
        }}
        className=" min-h-[200px]"
      >
        <EditableDataGrid
          nextRow={nextRow}
          keyDown={keyDown}
          columns={columns}
          data={rows}
          onScannerClick={
            isDeviceHaveCamera
              ? (e) => {
                  setScannerItem(e);
                  setScannerStatus(true);
                }
              : false
          }
          deletRow={deletRow}
          onEditCell={CellEdit}
          firstInputRef={inputRef}
          onCellDoubleClick={(e) => {
            if (e.column.editable && e.column.field !== "EXP_DATE") {
              if (true) {
                dispatch(setnumericKeyboardType(e.column.field));
                dispatch(setnumericKeyboardStatus(true));
                dispatch(
                  setIssueStockItem({
                    title: e.column.field,

                    id: e.row.original.id,
                    value: e.value,
                  })
                );
              } else {
              }
            }
          }}
        />
      </div>

      <div className="flex  mt-[30px]">
        <div
          style={{ border: "1px solid #b5b3b3", borderRadius: "8px" }}
          className="p-3 bg-white "
        >
          <div className="-mt-7 bg-white text-[15px] font-semibold w-fit px-2">
            Taxes
          </div>
          <div className={footerGrid}>
            {muiTextBox ? (
              <TextBoxMui
                readOnly={true}
                type={"number"}
                value={cgstTotal.toFixed(2)}
                label={"Total CGST"}
                align={"right"}
              />
            ) : (
              <GeniustextInput
                title={"Total CGST"}
                type={"number"}
                align={"right"}
                value={cgstTotal.toFixed(2)}
                placeholder={"0.00"}
                readOnly
              />
            )}
            {muiTextBox ? (
              <TextBoxMui
                readOnly={true}
                type={"number"}
                align={"right"}
                value={sgstTotal.toFixed(2)}
                label={"Total SGST"}
              />
            ) : (
              <GeniustextInput
                title={"Total SGST"}
                align={"right"}
                type={"Number"}
                value={sgstTotal.toFixed(2)}
                placeholder={"0.00"}
                readOnly
              />
            )}
            {muiTextBox ? (
              <TextBoxMui
                readOnly={true}
                align={"right"}
                type={"number"}
                value={igstTotal.toFixed(2)}
                label={"Total IGST"}
              />
            ) : (
              <GeniustextInput
                title={"Total IGST"}
                align={"right"}
                type={"Number"}
                value={igstTotal.toFixed(2)}
                placeholder={"0.00"}
                readOnly
              />
            )}
            {muiTextBox ? (
              <TextBoxMui
                readOnly={true}
                align={"right"}
                type={"number"}
                value={vatTotal.toFixed(2)}
                label={"Total VAT"}
              />
            ) : (
              <GeniustextInput
                title={"Total VAT"}
                align={"right"}
                type={"Number"}
                value={vatTotal.toFixed(2)}
                placeholder={"0.00"}
                readOnly
              />
            )}
            {muiTextBox ? (
              <TextBoxMui
                readOnly={true}
                align={"right"}
                type={"number"}
                value={surchargeTotal.toFixed(2)}
                label={"Total Surcharge"}
              />
            ) : (
              <GeniustextInput
                title={"Total Surcharge"}
                align={"right"}
                type={"Number"}
                value={surchargeTotal.toFixed(2)}
                placeholder={"0.00"}
                readOnly
              />
            )}

            {muiTextBox ? (
              <TextBoxMui
                readOnly={true}
                align={"right"}
                type={"number"}
                value={tcsTotal.toFixed(2)}
                label={"Total TCS"}
              />
            ) : (
              <GeniustextInput
                title={"Total TCS"}
                type={"Number"}
                align={"right"}
                value={tcsTotal.toFixed(2)}
                placeholder={"0.00"}
                readOnly
              />
            )}

            {muiTextBox ? (
              <TextBoxMui
                readOnly={true}
                align={"right"}
                type={"number"}
                value={cessTotal.toFixed(2)}
                label={"Total Cess"}
              />
            ) : (
              <GeniustextInput
                align={"right"}
                title={"Total Cess"}
                type={"Number"}
                value={cessTotal.toFixed(2)}
                placeholder={"0.00"}
                readOnly
              />
            )}

            {muiTextBox ? (
              <TextBoxMui
                readOnly={true}
                type={"number"}
                value={qntyTotal}
                label={"Total Qnty."}
              />
            ) : (
              <GeniustextInput
                title={"Total Qnty."}
                type={"Number"}
                width="110px"
                value={qntyTotal}
                placeholder={"0.00"}
                readOnly
              />
            )}
          </div>
        </div>
        <div className="flex ml-3 flex-1">
          <div
            style={{ border: "1px solid #b5b3b3", borderRadius: "8px" }}
            className="p-3 bg-white flex-1 "
          >
            <div className="-mt-7 bg-white text-[15px] font-semibold w-fit px-2">
              Additions
            </div>
            <div className={footerGrid2}>
              {muiTextBox ? (
                <TextBoxMui
                  refrance={frieghtRef}
                  onKeyDown={(e) => {
                    if (e.code === "Enter" || e.code === "NumpadEnter") {
                      const nearestInput = document.getElementById("charge");
                      // Focus on the nearest input if it exists
                      if (nearestInput) {
                        nearestInput.focus();
                      }
                    }
                  }}
                  bgColor="#f1f5f9"
                  type={"number"}
                  align={"right"}
                  onFocus={(e) => e.target.select()}
                  onChange={(e) =>
                    setPartyDetails((o) => {
                      return {
                        ...o,
                        FREIGHT: e.target.value ? e.target.value : 0,
                      };
                    })
                  }
                  value={partyDetails.FREIGHT}
                  label={"Add Freight"}
                />
              ) : (
                <GeniustextInput
                  title={"Add Freight"}
                  type={"number"}
                  onFocus={(e) => {
                    e.current.select();
                  }}
                  align={"right"}
                  placeholder={"0.00"}
                  value={partyDetails.FREIGHT}
                  onChange={(e) =>
                    setPartyDetails((o) => {
                      return {
                        ...o,
                        FREIGHT: e.target.value ? e.target.value : 0,
                      };
                    })
                  }
                />
              )}

              {muiTextBox ? (
                <TextBoxMui
                  onKeyDown={(e) => {
                    if (e.code === "Enter" || e.code === "NumpadEnter") {
                      const nearestInput =
                        document.getElementById("additional");
                      // Focus on the nearest input if it exists
                      if (nearestInput) {
                        nearestInput.focus();
                      }
                    }
                  }}
                  align={"right"}
                  bgColor="#f1f5f9"
                  id={"charge"}
                  type={"number"}
                  onFocus={(e) => e.target.select()}
                  onChange={(e) =>
                    setPartyDetails((o) => {
                      return {
                        ...o,
                        ADD_CHARGES: e.target.value ? e.target.value : 0,
                      };
                    })
                  }
                  value={partyDetails.ADD_CHARGES}
                  label={"Add Charges"}
                />
              ) : (
                <GeniustextInput
                  title={"Add Charges"}
                  type={"number"}
                  align={"right"}
                  placeholder={"0.00"}
                  value={partyDetails.ADD_CHARGES}
                  onChange={(e) =>
                    setPartyDetails((o) => {
                      return {
                        ...o,
                        ADD_CHARGES: e.target.value ? e.target.value : 0,
                      };
                    })
                  }
                />
              )}

              {muiTextBox ? (
                <TextBoxMui
                  id={"additional"}
                  type={"number"}
                  onFocus={(e) => e.target.select()}
                  align={"right"}
                  bgColor="#f1f5f9"
                  onChange={(e) =>
                    setPartyDetails((o) => {
                      return {
                        ...o,
                        ADDITIONAL_CESS: e.target.value ? e.target.value : 0,
                      };
                    })
                  }
                  onKeyDown={(e) => {
                    if (e.code === "Enter" || e.code === "NumpadEnter") {
                      const nearestInput =
                        document.getElementById("SCHEME_AMOUNT");
                      // Focus on the nearest input if it exists
                      if (nearestInput) {
                        nearestInput.focus();
                      }
                    }
                  }}
                  value={partyDetails.ADDITIONAL_CESS}
                  label={"Additional CESS"}
                />
              ) : (
                <GeniustextInput
                  title={"Additional CESS"}
                  type={"number"}
                  align={"right"}
                  placeholder={"0.00"}
                  value={partyDetails.ADDITIONAL_CESS}
                  onChange={(e) =>
                    setPartyDetails((o) => {
                      return {
                        ...o,
                        ADDITIONAL_CESS: e.target.value ? e.target.value : 0,
                      };
                    })
                  }
                />
              )}
            </div>
          </div>
          <div
            style={{ border: "1px solid #b5b3b3", borderRadius: "8px" }}
            className="p-3 ml-3  bg-white flex-1"
          >
            <div className="-mt-7 bg-white text-[15px] font-semibold w-fit px-2">
              Less & Discount
            </div>
            <div className={footerGrid2}>
              {muiTextBox ? (
                <TextBoxMui
                  type={"number"}
                  align={"right"}
                  readOnly={true}
                  value={disqTotal.toFixed(2)}
                  label={"Total Discount"}
                />
              ) : (
                <GeniustextInput
                  title={"Total Discount"}
                  align={"right"}
                  type={"number"}
                  value={disqTotal.toFixed(2)}
                  placeholder={"0.00"}
                  readOnly
                />
              )}

              {muiTextBox ? (
                <TextBoxMui
                  align={"right"}
                  type={"number"}
                  id={"SCHEME_AMOUNT"}
                  bgColor="#f1f5f9"
                  onFocus={(e) => e.target.select()}
                  onChange={(e) =>
                    setPartyDetails((o) => {
                      return {
                        ...o,
                        SCHEME_AMOUNT: e.target.value ? e.target.value : 0,
                      };
                    })
                  }
                  onKeyDown={(e) => {
                    if (e.code === "Enter" || e.code === "NumpadEnter") {
                      const nearestInput =
                        document.getElementById("LESS_CHARGES");
                      // Focus on the nearest input if it exists
                      if (nearestInput) {
                        nearestInput.focus();
                      }
                    }
                  }}
                  value={partyDetails.SCHEME_AMOUNT}
                  label={"Less Scheme Amt."}
                />
              ) : (
                <GeniustextInput
                  title={"Less Scheme Amt."}
                  type={"Number"}
                  align={"right"}
                  placeholder={"0.00"}
                  bgColor="#f1f5f9"
                  onChange={(e) =>
                    setPartyDetails((o) => {
                      return {
                        ...o,
                        SCHEME_AMOUNT: e.target.value ? e.target.value : 0,
                      };
                    })
                  }
                  value={partyDetails.SCHEME_AMOUNT}
                />
              )}

              {muiTextBox ? (
                <TextBoxMui
                  type={"number"}
                  id={"LESS_CHARGES"}
                  onFocus={(e) => e.target.select()}
                  align={"right"}
                  bgColor="#f1f5f9"
                  onKeyDown={(e) => {
                    IsEnterPressed(e).then((v) => {
                      if (v) {
                        setAlertTwoButtonModal({
                          title: "Alert",
                          msg: "Do you want to save this data?",
                          status: true,
                          button1: "Yes",
                          button2: "No",
                          button1Click: () => {
                            setAlertTwoButtonModal((o) => {
                              return {
                                ...o,
                                status: false,
                              };
                            });
                            savePurchaseBill();
                          },
                          button2Click: () => {
                            setAlertTwoButtonModal((o) => {
                              return {
                                ...o,
                                status: false,
                              };
                            });
                          },
                        });
                      }
                    });
                  }}
                  onChange={(e) => {
                    setPartyDetails((o) => {
                      return {
                        ...o,
                        LESS_CHARGES: e.target.value,
                      };
                    });
                  }}
                  value={partyDetails.LESS_CHARGES}
                  label={"Less Charge"}
                />
              ) : (
                <GeniustextInput
                  title={"Less Charge"}
                  align={"right"}
                  type={"Number"}
                  value={partyDetails.LESS_CHARGES}
                  onChange={(e) => {
                    setPartyDetails((o) => {
                      return {
                        ...o,
                        LESS_CHARGES: e.target.value,
                      };
                    });
                  }}
                  placeholder={"0.00"}
                />
              )}
            </div>
          </div>
          <div
            style={{ border: "1px solid #b5b3b3", borderRadius: "8px" }}
            className="px-3 ml-3 bg-white flex-1 "
          >
            <div className={footerGrid2}>
              {muiTextBox ? (
                <TextBoxMui
                  type={"number"}
                  align={"right"}
                  readOnly={true}
                  value={totalSum.toFixed(2)}
                  label={"Total"}
                />
              ) : (
                <GeniustextInput
                  title={"Total"}
                  align={"right"}
                  type={"number"}
                  value={totalSum.toFixed(2)}
                  placeholder={"0.00"}
                  readOnly
                />
              )}
              {muiTextBox ? (
                <TextBoxMui
                  type={"number"}
                  align={"right"}
                  readOnly={true}
                  value={roundOff.toFixed(2)}
                  label={"Round Off"}
                />
              ) : (
                <GeniustextInput
                  title={"Round Off"}
                  align={"right"}
                  type={"Number"}
                  placeholder={"0.00"}
                  value={roundOff.toFixed(2)}
                  readOnly
                />
              )}

              {muiTextBox ? (
                <TextBoxMui
                  align={"right"}
                  type={"number"}
                  readOnly={true}
                  fontWeight={"700"}
                  value={grandTotal}
                  label={"Grand Total"}
                  color={"black"}
                  fontSize={"15px"}
                />
              ) : (
                <GeniustextInput
                  title={"Grand Total"}
                  type={"Number"}
                  titleBold={true}
                  align={"right"}
                  value={grandTotal}
                  placeholder={"0.00"}
                  readOnly
                />
              )}
            </div>
          </div>
          <div
            style={{
              border: "1px solid #b5b3b3",
              borderRadius: "8px",
              display:
                windowWidth < 1280 || (windowWidth > 1434 && windowWidth < 1800)
                  ? "none"
                  : "block",
            }}
            className="px-3 ml-5 bg-white  "
          >
            <div className={footerGrid3}>
              {muiTextBox ? (
                <textarea
                  type={"text"}
                  placeholder="Remarks"
                  value={partyDetails.REMARKS}
                  onChange={(t) =>
                    setPartyDetails((e) => {
                      return {
                        ...e,
                        REMARKS: toProperCase(t.target.value),
                      };
                    })
                  }
                  className="bg-white h-[50px] p-1 outline-none border  rounded-sm p "
                  label={"Remarks"}
                />
              ) : (
                <GeniustextInput
                  title={"Remarks"}
                  type={"text"}
                  value={partyDetails.REMARKS}
                  onChange={(t) =>
                    setPartyDetails((e) => {
                      return {
                        ...e,
                        REMARKS: toProperCase(t.target.value),
                      };
                    })
                  }
                  label={"Remarks"}
                />
              )}

              <div className=" flex justify-end ">
                <div className="mr-1">
                  <PrintButton
                    onClick={() => {
                      if (rows.find((o) => o.ICODE && o.ITEMNAME)) {
                        setIsClearData(false);
                        setBarCodeList(rows);
                        setBarCodeListStatus(true);
                      } else {
                        dispatch(
                          setAlertWithTitle({
                            title: "Alert",
                            msg: "Nothing found to print",
                          })
                        );
                      }
                    }}
                  />
                </div>
                {partyDetails.INVNO ? (
                  <ModifyButton onClick={savePurchaseBill} />
                ) : (
                  <SaveButton onClick={savePurchaseBill} />
                )}

                <UndoButton onClick={clearState} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          display:
            windowWidth < 1280 || (windowWidth > 1434 && windowWidth < 1800)
              ? "flex"
              : "none",
        }}
        className=" mt-3"
      >
        <div className="flex">
          <label className="flex items-center">Remarks</label>
          <input
            style={{
              width: windowWidth <= 1300 ? "340px" : "460px",
              border: "1px solid #b5b3b3",
              borderRadius: "5px",
            }}
            className="p-1 ml-3 focus:outline-none"
            value={partyDetails.REMARKS}
            onChange={(t) =>
              setPartyDetails((e) => {
                return {
                  ...e,
                  REMARKS: toProperCase(t.target.value),
                };
              })
            }
          />
        </div>
        <div className="ml-3 flex justify-end w-[660px]">
          <div className="mr-1">
            <PrintButton
              onClick={() => {
                if (rows.find((o) => o.ICODE && o.ITEMNAME)) {
                  setBarCodeList(rows);
                  setIsClearData(false);

                  setBarCodeListStatus(true);
                } else {
                  dispatch(
                    setAlertWithTitle({
                      title: "Alert",
                      msg: "Nothing found to print",
                    })
                  );
                }
              }}
            />
          </div>
          {partyDetails.INVNO ? (
            <ModifyButton onClick={savePurchaseBill} />
          ) : (
            <SaveButton onClick={savePurchaseBill} />
          )}

          <UndoButton onClick={clearState} />
        </div>
      </div>
      <div
        style={{
          display: "none",
        }}
      >
        <div>
          <GeniusTableForReports
            customeHeader={
              <CustomHeader
                currentINVNO={currentINVNO}
                partyDetails={partyDetails}
              />
            }
            data={rows.filter((row) => row.ITEMNAME !== "")}
            columns={printColumns}
            footer={
              <Footer
                columns={printColumns}
                rows={rows}
                partyDetails={partyDetails}
              />
            }
            headerWidth={true}
            marginTop={"500px"}
          />
        </div>
      </div>
      <ItemMasterHelp
        searchText={searchText}
        status={itemMasterHelpStatus}
        onClose={() => {
          setSearchText("");

          setItemMasterHelpStatus(false);
        }}
        setSearchText={setSearchText}
        onRowClick={(row) => {
          setSearchText("");
          setItemMasterHelpStatus(false);
          const d = {
            id: rowId,
            code: "Enter",
            target: {
              value: row.row.ICODE,
            },
          };
          keyDown(d, "ICODE", d.id);
        }}
      />
      <ModNumericKeyboard
        onChange={(e) => {
          if (e.field === "ICODE") {
            const d = {
              id: e.id,
              code: "Enter",
              target: {
                value: e.value,
              },
            };

            keyDown(d, "ICODE", e.id);
          } else {
            CellEdit(e);
          }
        }}
        editType={""}
        mode={"dark"}
      />
      <BarcodeScanner
        setStatus={setScannerStatus}
        status={scannerStatus}
        onChange={(o) => {
          keyDown(
            { target: { value: o }, code: "Enter" },
            "ICODE",
            scannerItem
          );
        }}
      />
      {scanHistoryStatus ? (
        <div className="fixed inset-0 z-[1190] flex items-center justify-center bg-black/40 px-4">
          <div className="max-h-[82vh] w-[min(900px,94vw)] overflow-hidden rounded-md bg-white shadow-xl">
            <div className="flex items-center justify-between border-b px-5 py-3">
              <div>
                <div className="text-[18px] font-semibold">
                  Scanned Purchase PDF History
                </div>
                <div className="text-[12px] text-gray-500">
                  Last {PURCHASE_SCAN_HISTORY_LIMIT} scans on this device
                </div>
              </div>
              <button
                type="button"
                className="rounded border px-3 py-1 text-sm"
                onClick={() => setScanHistoryStatus(false)}
              >
                Close
              </button>
            </div>
            <div className="max-h-[calc(82vh-58px)] overflow-y-auto p-4">
              {scannedPurchaseHistory.length ? (
                <div className="overflow-x-auto rounded border">
                  <table className="min-w-full text-left text-sm">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="px-3 py-2">Scanned</th>
                        <th className="px-3 py-2">File</th>
                        <th className="px-3 py-2">Document No.</th>
                        <th className="px-3 py-2">Seller</th>
                        <th className="px-3 py-2 text-right">Total</th>
                        <th className="px-3 py-2 text-right">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {scannedPurchaseHistory.map((entry) => (
                        <tr key={entry.id} className="border-t">
                          <td className="px-3 py-2">
                            {moment(entry.scannedAt).format(
                              "DD-MM-YYYY hh:mm A"
                            )}
                          </td>
                          <td className="px-3 py-2">{emptyText(entry.fileName)}</td>
                          <td className="px-3 py-2">
                            {emptyText(entry.documentNumber)}
                          </td>
                          <td className="px-3 py-2">
                            {emptyText(entry.sellerName)}
                          </td>
                          <td className="px-3 py-2 text-right">
                            {emptyText(entry.grandTotal)}
                          </td>
                          <td className="px-3 py-2 text-right">
                            <button
                              type="button"
                              className="rounded border border-[#e94a05] px-3 py-1 text-[#e94a05]"
                              onClick={() => openScannedHistoryEntry(entry)}
                            >
                              View
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="rounded border border-dashed p-8 text-center text-gray-500">
                  No scanned purchase PDFs yet.
                </div>
              )}
            </div>
          </div>
        </div>
      ) : null}
      {pdfModalStatus && purchasePdfDetails ? (
        <div className="fixed inset-0 z-[1200] flex items-center justify-center bg-black/40 px-4">
          <div className="max-h-[88vh] w-[min(1100px,96vw)] overflow-hidden rounded-md bg-white shadow-xl">
            <div className="flex items-center justify-between border-b px-5 py-3">
              <div>
                <div className="text-[18px] font-semibold">
                  Purchase PDF Details
                </div>
                <div className="text-[12px] text-gray-500">
                  {scanFileName || file?.name || "Scanned purchase PDF"}
                </div>
              </div>
              <button
                type="button"
                className="rounded border px-3 py-1 text-sm"
                onClick={() => {
                  setPdfmodalStatus(false);
                  setFile("");
                }}
              >
                Close
              </button>
            </div>

            <div className="max-h-[calc(88vh-60px)] overflow-y-auto p-5">
              {resolvedPurchasePdfDetails ? (
                <div className="mb-5 rounded border border-orange-200 bg-orange-50 p-3">
                  <div className="flex flex-wrap items-center justify-between gap-3">
                    <div>
                      <div className="font-semibold">Review Purchase Match</div>
                      <div className="text-sm text-gray-700">
                        Party:{" "}
                        {resolvedPurchasePdfDetails.party.bestMatch
                          ? `${resolvedPurchasePdfDetails.party.bestMatch.party.NAME} (${resolvedPurchasePdfDetails.party.bestMatch.score}%)`
                          : "No match"}{" "}
                        | Items matched:{" "}
                        {
                          resolvedPurchasePdfDetails.items.filter(
                            (item) => item.bestMatch?.status === "matched"
                          ).length
                        }
                        /{resolvedPurchasePdfDetails.items.length}
                      </div>
                    </div>
                    <button
                      type="button"
                      className="rounded-md bg-[#e94a05] px-4 py-2 text-sm font-semibold text-white disabled:bg-gray-300"
                      disabled={!resolvedPurchasePdfDetails.readyToApply}
                      onClick={applyScannedPurchaseToBill}
                    >
                      Apply Matched Data
                    </button>
                  </div>
                  {!resolvedPurchasePdfDetails.readyToApply ? (
                    <div className="mt-2 text-xs text-gray-600">
                      Apply is enabled when party or any scanned item is matched
                      above 20%.
                    </div>
                  ) : null}
                </div>
              ) : null}

              <div className="grid grid-cols-2 gap-3 md:grid-cols-5">
                <PdfInfo label="Type" value={purchasePdfDetails.documentType} />
                <PdfInfo
                  label="Document No."
                  value={purchasePdfDetails.documentNumber}
                />
                <PdfInfo
                  label="Issue Date"
                  value={purchasePdfDetails.issueDate}
                />
                <PdfInfo label="Due Date" value={purchasePdfDetails.dueDate} />
                <PdfInfo label="Currency" value={purchasePdfDetails.currency} />
              </div>

              <div className="mt-5 grid grid-cols-1 gap-3 md:grid-cols-2">
                <PdfParty
                  title="Seller"
                  party={purchasePdfDetails.partyDetails?.seller}
                />
                <PdfParty
                  title="Buyer"
                  party={purchasePdfDetails.partyDetails?.buyer}
                />
                <PdfParty
                  title="Bill To"
                  party={purchasePdfDetails.partyDetails?.billTo}
                />
                <PdfParty
                  title="Ship To"
                  party={purchasePdfDetails.partyDetails?.shipTo}
                />
              </div>

              {resolvedPurchasePdfDetails ? (
                <div className="mt-5 rounded border">
                  <div className="border-b bg-gray-100 px-3 py-2 font-semibold">
                    DB Match Result
                  </div>
                  <div className="grid grid-cols-1 gap-3 p-3 md:grid-cols-2">
                    <div className="rounded border p-3">
                      <div className="mb-2 font-semibold">Detected Party</div>
                      <PdfLine
                        label="PDF Seller"
                        value={resolvedPurchasePdfDetails.party.seller?.name}
                      />
                      <PdfLine
                        label="DB Party"
                        value={
                          resolvedPurchasePdfDetails.party.bestMatch?.party
                            ?.NAME
                        }
                      />
                      <PdfLine
                        label="Account No."
                        value={
                          resolvedPurchasePdfDetails.party.bestMatch?.party
                            ?.ACCOUNT_NO
                        }
                      />
                      <PdfLine
                        label="Confidence"
                        value={
                          resolvedPurchasePdfDetails.party.bestMatch
                            ? `${resolvedPurchasePdfDetails.party.bestMatch.score}%`
                            : "0%"
                        }
                      />
                      <PdfLine
                        label="Status"
                        value={
                          resolvedPurchasePdfDetails.party.bestMatch?.status ||
                          "unmatched"
                        }
                      />
                    </div>

                    <div className="rounded border p-3">
                      <div className="mb-2 font-semibold">Warnings</div>
                      <div className="text-sm text-gray-700">
                        {resolvedPurchasePdfDetails.readyToApply
                          ? "All scanned rows are ready to apply."
                          : "Some party or item matches need manual review before saving."}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              <div className="mt-5 overflow-x-auto rounded border">
                <table className="min-w-full text-left text-sm">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="px-3 py-2">Item</th>
                      <th className="px-3 py-2">DB Match</th>
                      <th className="px-3 py-2">SKU</th>
                      <th className="px-3 py-2">HSN/SAC</th>
                      <th className="px-3 py-2 text-right">Qty</th>
                      <th className="px-3 py-2">Unit</th>
                      <th className="px-3 py-2 text-right">Rate</th>
                      <th className="px-3 py-2 text-right">Tax</th>
                      <th className="px-3 py-2 text-right">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {purchasePdfDetails.items?.length ? (
                      purchasePdfDetails.items.map((item, index) => (
                        <tr key={`${item.itemName}-${index}`} className="border-t">
                          <td className="px-3 py-2">
                            <div className="font-medium">
                              {emptyText(item.itemName)}
                            </div>
                            <div className="text-[12px] text-gray-500">
                              {emptyText(item.description)}
                            </div>
                          </td>
                          <td className="px-3 py-2">
                            <MatchBadge
                              match={
                                resolvedPurchasePdfDetails?.items?.[index]
                                  ?.bestMatch
                              }
                            />
                            <div className="mt-1 text-[12px] text-gray-500">
                              {emptyText(
                                resolvedPurchasePdfDetails?.items?.[index]
                                  ?.bestMatch?.item?.ITEMNAME
                              )}
                            </div>
                          </td>
                          <td className="px-3 py-2">{emptyText(item.sku)}</td>
                          <td className="px-3 py-2">{emptyText(item.hsnSac)}</td>
                          <td className="px-3 py-2 text-right">
                            {emptyText(item.quantity)}
                          </td>
                          <td className="px-3 py-2">{emptyText(item.unit)}</td>
                          <td className="px-3 py-2 text-right">
                            {emptyText(item.rate)}
                          </td>
                          <td className="px-3 py-2 text-right">
                            {emptyText(item.taxAmount)}
                          </td>
                          <td className="px-3 py-2 text-right">
                            {emptyText(item.amount)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="px-3 py-5 text-center text-gray-500" colSpan={9}>
                          No line items found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="mt-5 grid grid-cols-1 gap-3 md:grid-cols-3">
                <PdfTotal title="Totals" totals={purchasePdfDetails.totals} />
                <div className="rounded border p-3">
                  <div className="mb-2 font-semibold">Payment</div>
                  <PdfLine
                    label="Method"
                    value={purchasePdfDetails.payment?.method}
                  />
                  <PdfLine
                    label="Transaction ID"
                    value={purchasePdfDetails.payment?.transactionId}
                  />
                </div>
                <div className="rounded border p-3">
                  <div className="mb-2 font-semibold">Notes</div>
                  <div className="whitespace-pre-wrap text-sm text-gray-700">
                    {emptyText(purchasePdfDetails.notes)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Datagrid;

const PdfInfo = ({ label, value }) => (
  <div className="rounded border p-3">
    <div className="text-[12px] text-gray-500">{label}</div>
    <div className="mt-1 font-semibold">{emptyText(value)}</div>
  </div>
);

const PdfLine = ({ label, value }) => (
  <div className="flex justify-between gap-3 border-b py-1 last:border-b-0">
    <span className="text-gray-500">{label}</span>
    <span className="text-right font-medium">{emptyText(value)}</span>
  </div>
);

const PdfParty = ({ title, party }) => (
  <div className="rounded border p-3">
    <div className="mb-2 font-semibold">{title}</div>
    <PdfLine label="Name" value={party?.name} />
    <PdfLine label="Address" value={party?.address} />
    <PdfLine label="Phone" value={party?.phone} />
    <PdfLine label="Email" value={party?.email} />
    <PdfLine label="Tax ID" value={party?.taxId} />
  </div>
);

const PdfTotal = ({ title, totals }) => (
  <div className="rounded border p-3">
    <div className="mb-2 font-semibold">{title}</div>
    <PdfLine label="Subtotal" value={totals?.subtotal} />
    <PdfLine label="Discount" value={totals?.discount} />
    <PdfLine label="Tax" value={totals?.tax} />
    <PdfLine label="Shipping" value={totals?.shipping} />
    <PdfLine label="Grand Total" value={totals?.grandTotal} />
    <PdfLine label="Amount Paid" value={totals?.amountPaid} />
    <PdfLine label="Balance Due" value={totals?.balanceDue} />
  </div>
);

const MatchBadge = ({ match }) => {
  const status = match?.status || "unmatched";
  const styles = {
    matched: "border-green-300 bg-green-50 text-green-700",
    review: "border-yellow-300 bg-yellow-50 text-yellow-700",
    unmatched: "border-red-300 bg-red-50 text-red-700",
  };

  return (
    <span
      className={`inline-flex rounded border px-2 py-0.5 text-[12px] font-semibold ${
        styles[status] || styles.unmatched
      }`}
    >
      {status} {match?.score ? `${match.score}%` : ""}
    </span>
  );
};
